import { useContext } from "react";
import { DateTimeAudienceContext } from "../context/DateTimeAudienceContext";

export const useDateTimeAudienceContext = () => {
  const context = useContext(DateTimeAudienceContext);
  return context;
};
